import React from 'react';
import { Info, ChevronDown, ChevronUp } from 'lucide-react';

interface BudgetNoticeProps {
  title?: string;
  message: string;
}

export function BudgetNotice({ title = "Estimations et moyennes", message }: BudgetNoticeProps) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="bg-gray-50 dark:bg-gray-700/30 rounded-xl p-3.5 border border-gray-200/50 dark:border-gray-600/30 mb-6">
      <div className="flex items-center justify-between cursor-pointer" onClick={handleToggle}>
        <div className="flex items-center gap-2.5">
          <div className="p-1.5 bg-gray-200/50 dark:bg-gray-600/30 rounded-lg">
            <Info className="w-3.5 h-3.5 text-gray-500 dark:text-gray-400" />
          </div>
          <h3 className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">
            {title}
          </h3>
        </div>
        <button
          type="button"
          onClick={handleToggle}
          className="p-1 text-gray-400 dark:text-gray-500 hover:bg-gray-200/50 dark:hover:bg-gray-600/30 rounded-lg transition-colors"
        >
          {isExpanded ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
        </button>
      </div>

      <div className={`overflow-hidden transition-all duration-300 ${
        isExpanded ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
      }`}>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-2.5 leading-relaxed">
          {message}
        </p>
      </div>
    </div>
  );
}
